import moment from "moment";
import { Dialog } from "@mui/material";
import React, { useState } from "react";

import CustomDatePickerV2 from "views/pages/manage/common/commonComponents/CustomDatePicker-V2";
import { ReactComponent as CrossIcon } from "assets/img/svg/CrossIcon.svg";
import AButton from "views/pages/manage/common/form-fields-mui/AButton";
import { getReinitiate } from "../../util";

import styles from "./style.module.scss";
import { COOLING_PERIOD, formattedPrice } from "../constant";

const RepresentDialoge = ({
  isOpen,
  setOpen,
  row,
  setLoader,
  getPaymentDetail,
}) => {
  const [date, setDate] = useState(null);

  const handler = () => {
    getReinitiate(
      { ...row, date },
      setLoader,
      setOpen,
      setDate,
      getPaymentDetail
    );
  };

  return (
    <Dialog
      open={isOpen}
      PaperProps={{ sx: { maxWidth: "unset", borderRadius: "12px" } }}
    >
      <div className={`${styles["select-concession-popup-represent"]}`}>
        <div className="d-flex " style={{ justifyContent: "space-between" }}>
          {/* {loader&& <ALoader/>} */}
          <div>
            <div className="heading-4 color-dark">
              Represent {formattedPrice(row?.paidAmount)}
            </div>
          </div>
          <CrossIcon
            onClick={() => {
              setOpen(null);
              setDate(null);
            }}
          />
        </div>
        <div>
          <CustomDatePickerV2
            label="Date"
            // labelStyle={labelSyle}
            // style={{ input: { minHeight: "47px" } }}
            placeHolder="Select date"
            value={date}
            handler={(index, date) => {
              setDate(date);
            }}
            isStartDate={true}
            minDate={moment.max(moment(new Date()),moment(row?.dueDate).add(COOLING_PERIOD, "days"))}
            maxDate={new moment(row?.dueDate).add(15, "days")}
          />
        </div>
        <AButton
          variant={"primary_filled"}
          onClick={handler}
          className="button_remove_left_margin"
          disabled={!date}
        >
          Represent
        </AButton>
      </div>
    </Dialog>
  );
};
export default RepresentDialoge;
